module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "looping-rhombuses-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      staticClass: "rhombus",
      style: (rs),
      attrs: {
        "ikey": index
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b52a527e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/LoopingRhombusesSpinner.vue
// module id = 394
// module chunks = 1